import { Button, DatePicker, Space } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const PRESETS = [
  { label: "Hoy", days: 0 },
  { label: "7 dias", days: 7 },
  { label: "30 dias", days: 30 },
  { label: "90 dias", days: 90 },
];

function PeriodSelector({ value, onChange, loading }) {
  const [startDate, endDate] = value || [null, null];

  const handlePreset = (days) => {
    const end = dayjs();
    const start = days === 0 ? dayjs() : dayjs().subtract(days, "day");
    onChange([start, end]);
  };

  const handleRangeChange = (dates) => {
    onChange(dates);
  };

  const isPresetActive = (days) => {
    if (!startDate || !endDate) return false;
    const expectedStart = days === 0 ? dayjs() : dayjs().subtract(days, "day");
    const expectedEnd = dayjs();
    return (
      startDate.format("YYYY-MM-DD") === expectedStart.format("YYYY-MM-DD") &&
      endDate.format("YYYY-MM-DD") === expectedEnd.format("YYYY-MM-DD")
    );
  };

  return (
    <div className="flex flex-wrap items-center gap-2 mb-4">
      <Space.Compact>
        {PRESETS.map((preset) => (
          <Button
            key={preset.days}
            type={isPresetActive(preset.days) ? "primary" : "default"}
            onClick={() => handlePreset(preset.days)}
            disabled={loading}
          >
            {preset.label}
          </Button>
        ))}
      </Space.Compact>
      <RangePicker
        value={[startDate, endDate]}
        onChange={handleRangeChange}
        format="DD/MM/YYYY"
        disabled={loading}
        className="ml-2"
      />
    </div>
  );
}

export default PeriodSelector;
